<template>
  <form @submit.prevent="submitForm()">
    <p>Введите основной номер телефона из вашего профиля, а мы пришлём смс с кодом для получения нового пароля.</p>
    <div class="my-1">
      <div class="input-group">
        <div class="input-group-text"><font-awesome-icon icon="fa-solid fa-phone" /></div>
        <input
          v-maska="objRemind.phone"
          :data-maska="objRemind.mask.phone"
          type="tel"
          name="phone"
          v-model="form.phone"
          @maska="onMaskaRemindPhone"
          class="form-control maska-phone"
          :class="{
            'is-invalid': !objRemind.phone.completed,
            'is-valid': objRemind.phone.completed,
          }"
          :placeholder="objRemind.mask.phone.replaceAll('#', 'x')" />
        <div class="invalid-feedback">{{ errors.form.phone }}</div>
      </div>
    </div>

    <div data-error v-if="errors.form.common.length" class="alert alert-info mb-1 mt-3 px-2 py-1" role="alert">
      {{ errors.form.common }}
    </div>

    <div class="mt-2 mb-1 text-end">
      <button
        type="submit"
        class="btn btn-primary"
        :disabled="!objRemind.phone.completed || isLoading"
        title="Получить код для нового пароля">
        <font-awesome-icon icon="fa-solid fa-check"></font-awesome-icon> Отправить
      </button>
    </div>
  </form>
</template>

<script>
import axios from 'axios';

import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faCheck, faPhone } from '@fortawesome/free-solid-svg-icons';
library.add(faCheck, faPhone);

import { vMaska } from 'maska';
// import { countries, defaultFormat } from '@/constants/countries'

export default {
  directives: { maska: vMaska },
  data: function () {
    return {
      isLoading: false,
      //
      form: {
        _token: this.csrf,
        phone: '',
      },
      errors: {
        form: {
          phone: '',
          common: '',
        },
      },
      // maska:
      objRemind: {
        phone: {
          completed: false,
          masked: '',
          unmasked: '',
        },
        raw: {
          phone: '',
        },
        country: {
          phone: '7',
        },
        mask: {
          phone: '+7 (###) ###-##-##',
        },
      },
    };
  },
  props: {
    csrf: {
      type: String,
      default: '',
    },
    phone: {
      type: String,
      default: '',
    },
    // тут не используется
    uid: {
      type: Number,
      default: 0,
    },
    until: {
      type: String,
      default: '',
    },
  },
  components: {
    FontAwesomeIcon,
  },
  methods: {
    submitForm() {
      // убрать старые ошибки
      Object.keys(this.errors.form).forEach((key) => {
        this.errors.form[key] = '';
      });

      if (this.form.phone === '') {
        this.errors.form.phone = 'Нужно ввести номер телефона.';
        return false;
      }

      this.isLoading = true;

      axios
        .post(`/backend/profile/remind/sms/request`, this.form)
        .then((res) => {
          const { data } = res;

          // ??? надо?
          if (data.message !== '') {
            this.$bs5utils.Snack.show('info', data.message, this.$store.getters.delay.info);
          }

          if (data.status == 'ok') {
            this.$emit('go-step', { step: 'step2', uid: data.uid, until: data.until, phone: this.form.phone });
          }

          if (data.status == 'error') {
            const errors = data.errors || {};
            const fieldErrors = errors.validation || {};
            const customErrors = errors.customErrors || {};
            const commonErrors = errors.common || [];

            Object.keys(fieldErrors).forEach((key) => {
              this.errors.form[key] = fieldErrors[key].join(' ');
            });

            Object.keys(customErrors).forEach((key) => {
              this.errors.form[key] = customErrors[key].join(' ');
            });

            this.errors.form.common = commonErrors.join(' ');
          }
        })
        .catch((err) => {
          this.errors.form.common = 'Ошибка на сервере, обновите страницу и попробуйте ещё раз.';
          console.error(err);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    //
    onMaskaRemindPhone(event) {
      this.objRemind.raw.phone = event.detail.unmasked;
    },
  },
};
</script>
